// Modules
import DevStudio from './modules/DevStudio'

window.DevStudio = new DevStudio();
//window.DevStudio_Bar = new DevStudio_Bar();